import React, { useEffect } from 'react'
import PageBody from '../../../components/pagebody/PageBody';
import Heading from '../../../components/heading/Heading';
import TextInput from '../../../components/input/textinput/TextInput';
import Button from '../../../components/button/Button';
import { BUTTON_TYPE } from '../../../components/button/constants';
import RichGrid from '../../../components/richgrid/RichGrid';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setAssigneeList, setFilterText, setRowsPerPage, setShowAddNoticePopup, setSkip } from '../NoticeSectionSlice';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant';
import Label from '../../../components/label/Label';
import { LABEL_WEIGHT } from '../../../components/label/constants';
import { deleteNotice, getAddNoticeDropDownData, getAssigneeList, getList, saveNotice, toggleArchiveNotice } from '../NoticeSectionSaga';
import { HEADING } from '../../../components/heading/constants/constants';
import styles from './NoticesList.styles';
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants';
import HorizontalProgressBar from '../../../components/progressbar/HorizontalProgressBar';
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown';
import Loadable from '../../../components/loadable/Loadable';
import { useState } from 'react';
import MultiSelectDropdownWLabel from '../../../components/dropdown/multiselectdropdownwlabel/MultiSelectDropdownWLabel';
import CalendarInputWDateFormat from '../../../components/input/calendarinput/CalendarInputWDateFormat';
import Popup from '../../../components/popup/Popup';
import DateUtils from '../../../../libs/utility/DateUtils';
import { ShowForAllowedPermissionsOnly } from '../../wrappers/ShowForAllowedPermissionsOnly';
import { PermissionReroute, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks';
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP, PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants';
import { NOTICES_STATES, NOTICES_STATES_MESSAGE_MAP } from '../constants';
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function NoticesList() {

	const { loadingState, skip, rowsPerPage, gridData, totalData, filterText, payersList, noticeList, assigneeList, showAddNoticePopup } = useSelector((state) => state[componentKey])
	const [newNoticeDetails, setNewNoticeDetails] = useState({})
	const NONE_SELECTED = "None Selected";
	const [selectedAssigneeLabel, setSelectedAssigneeLabel] = useState(NONE_SELECTED);
	const [addEditPopupLabel, setAddEditPopupLabel] = useState('Add Notice')
	const [searchText, setSearchText] = useState('');
	const [queryParams, setQueryParams] = useTxSearchParams();
	const dispatch = useDispatch();
	const navigate = useTxNavigate();
	const { permissions } = useUserPermissionsInfo();

	const handleViewDetails = (row) => {
		navigate(`${PAGE_PATH.VIEW}?NoticeID=${row.EncryptedNoticeID}`)
	}

	useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.VIEW_NOTICES, permissions, navigate, PAGE_PATH.DASHBOARD)
    },[permissions])

	useEffect(() => {
		dispatch(getAddNoticeDropDownData());
	}, [])


	useEffect(() => {
		dispatch(getList({
			NoticeName: filterText,
			page: (skip / rowsPerPage) + 1,
			pageSize: rowsPerPage
		}))
	}, [filterText, skip, rowsPerPage])

	useEffect(() => {
		if(showAddNoticePopup) {
			if (newNoticeDetails?.selectedPayer === undefined && payersList.length !== 0) {
				setNewNoticeDetails(prev => ({ ...prev, selectedPayer: payersList[0], noticeName: getNoticeName() }))
			}
	
			if (newNoticeDetails?.selectedNotices === undefined && noticeList.length !== 0) {
				setNewNoticeDetails(prev => ({ ...prev, selectedNotices: noticeList[0], noticeName: getNoticeName() }))
			}

			if (newNoticeDetails?.assignees !== undefined && !assigneeList?.find(assignee => assignee.checked)) {
				const assigneesArray = newNoticeDetails?.assignees.split(',').map(assignee => assignee.replace(" ", ''));
				dispatch(setAssigneeList(assigneeList.map(assignee => ({ ...assignee, checked: assigneesArray.includes(assignee.label.replace(' ', '')) }))))
			}
		}
	}, [showAddNoticePopup, newNoticeDetails?.assignees, newNoticeDetails?.selectedPayer, newNoticeDetails?.selectedNotices])

	useEffect(() => {
		if( showAddNoticePopup && newNoticeDetails?.selectedPayer !== undefined){
			dispatch(getAssigneeList({ payerId: newNoticeDetails.selectedPayer.value }))
		}
	}, [newNoticeDetails?.selectedPayer])

	useEffect(() => {
		setNewNoticeDetails(prev => ({ ...prev, noticeName: getNoticeName() }))
	}, [newNoticeDetails?.selectedNotices, newNoticeDetails?.selectedPayer])

	useEffect(() => {
        if (queryParams.get('action') === 'addnotice') {
            handleAddNotice();
		}
    }, [window.location])
	
	useEffect(() => {
		setSelectedAssigneeLabel(`${assigneeList.filter(opt => opt.checked)?.length ?? 'None'} Selected`)
	}, [assigneeList])


	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
		  dispatch(setFilterText(searchText))
		}, 1000)
	
		return () => clearTimeout(delayDebounceFn)
	  }, [searchText])

	const handleDeleteNotice = (row) => {
		dispatch(deleteNotice(row.EncryptedNoticeID))
	}

	const handleToggleArchieve = (row) => {
		dispatch(toggleArchiveNotice(row.EncryptedNoticeID))
	}

	const ACTIONS = {
		SELECT: 'Select',
		EDIT: 'Edit',
		DELETE: 'Delete',
		ARCHIVE: 'Archive/Unarchive',
	};

	const ACTIONS_LIST = [
		{ label: ACTIONS.SELECT, value: ACTIONS.SELECT, permissions: [] },
		{ label: ACTIONS.EDIT, value: ACTIONS.EDIT, permissions: PAGE_PERMISSIONS.VIEW_NOTICES},
		{ label: ACTIONS.DELETE, value: ACTIONS.DELETE, permissions: PAGE_PERMISSIONS.VIEW_NOTICES },
		{ label: ACTIONS.ARCHIVE, value: ACTIONS.ARCHIVE, permissions: PAGE_PERMISSIONS.VIEW_NOTICES },
	]

	const handleNoticeAction = (name, selectedOption, row) => {
		switch (selectedOption.value) {
			case ACTIONS.EDIT:
				dispatch(setShowAddNoticePopup(true));
				setAddEditPopupLabel('Edit Notice');
				const obj = {
					NoticeID: row.NoticeID,
					noticeName: row.NoticeName,
					dueDate: row.DueDate,
					selectedPayer: payersList.find(payer => payer.label === row.PayerName),
					selectedNotices: noticeList.find(notice => notice.value === row.NoticeName.split('-')[0].trim()),
					assignees: row.Assignees,
				}
				setNewNoticeDetails({ ...obj })
				break;
			case ACTIONS.DELETE:
				handleDeleteNotice(row)
				break;
			case ACTIONS.ARCHIVE:
				handleToggleArchieve(row)
				break;
		}
	}

	const NOTICES_LOGS_COLUMNS = [
		{
			field: "noticeTitle",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Notice Title</Label>,
			renderLogic: (row, idx) => <div style={styles.noticeName} onClick={() => handleViewDetails(row)}>{row.NoticeName}</div>
		},
		{
			field: "payerName",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Payer Name</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.PayerName}</span>
		},
		{
			field: "assignee",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Assignee(s)</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.Assignees}</span>
		},
		{
			field: "dueDate",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Due Date</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.DueDate}</span>
		},
		{
			field: "status",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Status</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.Status}</span>
		},
		{
			field: "progressStatus",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Progress/Status</Label>,
			renderLogic: (row, idx) => <div style={styles.horizontalPaddingForHorizontalProgress}>
					<HorizontalProgressBar value={row.Progress} iconName={null} showValue={true} />
				</div>
		},
		{
			field: "action",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Action</Label>,
			renderLogic: (row, idx) => (
				<SelectDropdown
					name="select"
					value={ACTIONS_LIST[0]}
					prefixProps={{ text: "" }}
					onSelectCb={(name, selectedOption) => handleNoticeAction(name, selectedOption, row)}
					options={ACTIONS_LIST}
					isClearable={false} />
				)
		},
	]
	
	const handleAddNotice = () => {
		queryParams.set('action', "addnotice");
		setQueryParams(queryParams);
		dispatch(setShowAddNoticePopup(true));
		setAddEditPopupLabel('Add Notice');
	}

	

	const handleMultiSelectChange = (option, index) => {
		dispatch(setAssigneeList(option))
		setSelectedAssigneeLabel(`${option.filter(opt => opt.checked)?.length ?? 'None'} Selected`)
	}



	const resetPopupDetails = () => {
		dispatch(setShowAddNoticePopup(false));
		setNewNoticeDetails({});
		setSelectedAssigneeLabel(NONE_SELECTED)
		queryParams.delete('action');
		setQueryParams(queryParams);
		dispatch(setAssigneeList(assigneeList.map(assignee => ({ ...assignee, checked: false }))))
	}

	
	const handleCreateNotice = () => {
		dispatch(saveNotice(
			{
				NoticeID: newNoticeDetails?.NoticeID ?? 0,
				NoticeName: newNoticeDetails?.noticeName,
				DueDate: newNoticeDetails?.dueDate,
				NoticeTypeCode: newNoticeDetails.selectedNotices.value,
				PayerID: newNoticeDetails.selectedPayer.value,
				Assignees: assigneeList.filter(assignee => assignee.checked).map(assignee => assignee.value).join(',')
			}
		))
	}

	const getNoticeName = () => {
		return `${newNoticeDetails?.selectedNotices?.value ?? ''} - ${newNoticeDetails?.selectedPayer?.label ?? ''} - ${DateUtils.dateFormatter(new Date(), 'MMM')} ${DateUtils.dateFormatter(new Date(), 'YYYY')}`
	}

	const handlePayerChange = (selectedOption) => {
		setNewNoticeDetails(prev => ({ ...prev, selectedPayer: selectedOption }))
		dispatch(getAssigneeList({ payerId: selectedOption.value }))
	}

	return (
		<PageBody>
			<Heading type={HEADING.H1}>Notices</Heading>
			<Loadable currentState={loadingState.state} loadingStates={[NOTICES_STATES.GRID_LOADING]} messageMap={NOTICES_STATES_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.actionsRow}>
					<div>
						<TextInput
							placeHolder='Search Notices'
							value={searchText}
							onChangeCb={(e) => setSearchText(e.target.value)}
						/>
					</div>
					<ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.VIEW_NOTICES}>
						<Button type={BUTTON_TYPE.PRIMARY} onClickCb={handleAddNotice}>Add Notices</Button>
					</ShowForAllowedPermissionsOnly>
				</div>
				<RichGrid

					data={gridData}
					columns={NOTICES_LOGS_COLUMNS}
					extractRowKey={(row) => row.ApplicationUserLogId}
					paginationProps={{
						skip: skip,
						take: rowsPerPage,
						takeOptions: ROW_SELECTION_OPTIONS,
						onChangeTakeCb: (newTake) => {
							dispatch(setRowsPerPage(newTake));
							dispatch(setSkip(0))
						},
						total: totalData,
						onChange: (take, t) => {
							dispatch(setRowsPerPage(take));
							dispatch(setSkip(t))
						},
					}}
				/>
			</Loadable>
			<ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.VIEW_NOTICES}>
				<Popup title={addEditPopupLabel} onCloseCb={resetPopupDetails} isPopupOpen={showAddNoticePopup} customPopupSyles={styles.popupCustomStyle} childrenStyles={styles.popupChildrenStyles}>
					<Loadable currentState={loadingState.state} loadingStates={[NOTICES_STATES.POPUP_LOADING]} messageMap={NOTICES_STATES_MESSAGE_MAP} isNewLoadable={true} preserveChildMount={true}>
						<div style={styles.addEditPopup}>
							<div style={styles.addEditPopupInputRow}>
								<Label><b>Payer*</b></Label>
								<SelectDropdown
									name="payerSelect"
									value={newNoticeDetails?.selectedPayer ?? payersList[0]}
									prefixProps={{ text: "" }}
									onSelectCb={(name, selectedOption) => handlePayerChange(selectedOption)}
									options={payersList}
									isClearable={false} />
							</div>
							<div style={styles.addEditPopupInputRow}>
								<Label><b>Notice Type*</b></Label>
								<SelectDropdown
									name="noticeSelect"
									value={newNoticeDetails?.selectedNotices ?? noticeList[0]}
									prefixProps={{ text: "" }}
									onSelectCb={(name, selectedOption) => setNewNoticeDetails(prev => ({ ...prev, selectedNotices: selectedOption }))}
									options={noticeList}
									isClearable={false} />
							</div>
							<div style={styles.addEditPopupInputRow}>
								<Label><b>Notice Name*</b></Label>
								<TextInput value={newNoticeDetails?.noticeName} disabled={true} />
							</div>
							<div style={styles.addEditPopupInputRow}>
								<Label><b>Assignee(s)</b></Label>
								<MultiSelectDropdownWLabel 
									label={selectedAssigneeLabel}
									options={assigneeList}
									onChangeCheckboxCb={(options, index) => handleMultiSelectChange(options, index)}
									buttonProps={[]}
								/>
							</div>
							<div style={styles.addEditPopupInputRow}>
								<Label><b>Due Date</b></Label>
								<CalendarInputWDateFormat
									name='dueDate'
									value={newNoticeDetails?.dueDate}
									onChangeCb={(e) => setNewNoticeDetails(prev => ({ ...prev, dueDate: e }))}
								/>
							</div>
						</div>
						<div style={styles.addEditPopupRow}>
							<Button onClickCb={handleCreateNotice}>Save</Button>
							<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={resetPopupDetails}>Cancel</Button>
						</div>
					</Loadable>
				</Popup>
			</ShowForAllowedPermissionsOnly>
		</PageBody>
	)
}